import type { TFormatDate } from '~/shared/types/format-date/TFormatDate';

const MONTHS_GENITIVE = [
  'Января',
  'Февраля',
  'Марта',
  'Апреля',
  'Мая',
  'Июня',
  'Июля',
  'Августа',
  'Сентября',
  'Октября',
  'Ноября',
  'Декабря',
];

const MONTHS_NOMINATIVE = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

const MONTHS_SHORT = [
  'янв',
  'февр',
  'март',
  'апр',
  'мая',
  'июня',
  'июля',
  'авг',
  'сент',
  'окт',
  'нояб',
  'дек',
];

const MONTHS_SHORT_NOMINATIVE = [
  'янв',
  'февр',
  'март',
  'апр',
  'май',
  'июнь',
  'июль',
  'авг',
  'сент',
  'окт',
  'нояб',
  'дек',
];

type MonthFormat = 'nominative' | 'genitive' | 'short' | 'shortNominative';

const MONTH_MAPS: Record<MonthFormat, string[]> = {
  nominative: MONTHS_NOMINATIVE,
  genitive: MONTHS_GENITIVE,
  short: MONTHS_SHORT,
  shortNominative: MONTHS_SHORT_NOMINATIVE,
};

export function getMonthName(
  monthIndex: number,
  format: MonthFormat = 'genitive',
): string {
  return MONTH_MAPS[format][monthIndex] ?? '';
}

function addZero(num: number): string {
  return num < 10 ? '0' + num : num.toString();
}

export function formatDate(format: TFormatDate, time?: string | null) {
  if (!time) {
    return '—';
  }

  const date = new Date(time);

  const day = date.getDate();

  const monthIndex = date.getMonth();
  const customMonth = date.getMonth() + 1;

  const year = date.getFullYear();

  const minutes = date.getMinutes();
  const hour = date.getHours();

  switch (format) {
    case 'standartDate':
      return `${addZero(day)}.${addZero(monthIndex + 1)}.${year} ${addZero(hour)}:${addZero(minutes)}`;
    case 'standartDateStrings':
      return `${addZero(day)}.${addZero(monthIndex + 1)} ${year} ${addZero(hour)}:${addZero(minutes)}`;
    case 'fullDate':
      return `${day} ${MONTHS_GENITIVE[monthIndex]} ${year}, ${hour}:${addZero(minutes)}`;
    case 'dayMonth':
      return `${day} ${MONTHS_GENITIVE[monthIndex]}`;
    case 'shortDate':
      return `${day}.${addZero(customMonth)}`;
    case 'shortDateYear':
      return `${day}.${addZero(customMonth)}.${addZero(year % 100)}`;

    default:
      return `${day} ${MONTHS_GENITIVE[monthIndex]} ${year}`;
  }
}
